import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-manufacturing-process',
  templateUrl: './manufacturing-process.component.html',
  styleUrls: ['./manufacturing-process.component.scss']
})
export class ManufacturingProcessComponent implements OnInit {
    @ViewChild('manufacturingProcessInput') manufacturingProcessInput!: ElementRef;
    manufacturingProcess!: string;

    constructor(private formService: FormService) {}

    ngOnInit(): void {
      this.manufacturingProcess = this.currentForm.get('manufacturingProcess')?.value;
    }
  
    public clearManufacturingProcessInputField() {
      this.manufacturingProcess = '';
      this.currentForm.patchValue({'manufacturingProcess': ''});
    }
  
    public updateManufacturingProcess(event: Event) {
      if(event && event.type === 'blur') {
        var target = document.activeElement;
        if(target && target.nodeValue === "cancel") {
          this.manufacturingProcess = '';
        }
      }
      this.currentForm.patchValue({'manufacturingProcess': this.manufacturingProcess});
    }
  
    public cancelUpdate() {
      this.manufacturingProcess = this.currentForm.get('manufacturingProcess')?.value;
    }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
